import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'tipoTurno'
})
export class TipoTurnoPipe implements PipeTransform {
  private readonly map: Record<number, string> = {
    0: 'Tarde - 07:00 - 15:59',
    1: 'Manhã - 16:00 - 23:59',
    2: 'Noite - 00:00 - 06:59'
  };

  transform(value: number | null | undefined): string {
    if (value === null || value === undefined) {
      return 'Não informado';
    }
    return this.map[value] ?? 'Não informado';
  }
}
